if ( $('ul.gfield_checkbox').length ) {
  $('ul.gfield_checkbox > li').addClass('checkbox');
}

if ( $('ul.gfield_radio').length ) {
  $('ul.gfield_radio > li').addClass('radio');
}